<!--
  GridLayout.vue

  대시보드에서 사용하는 그리드 레이아웃 컴포넌트

  NGF 1.2.0 수정 이력

  1) 위젯 리사이즈, 이동 관련 핸들러 추가
-->

<template>
  <div class="grid-stack">
    <grid-widget v-for="widget in widgets"
                 :x="widget.x"
                 :y="widget.y"
                 :w="widget.w"
                 :h="widget.h"
                 :i="widget.i"
                 :s="widget.s"
                 :n="widget.n"
                 :key="widget.i"
                 :uuid="uuid"
                 :opts="widget.opts"
                 :title="widget.title"
                 :is-vlan="widget.isVlan"
                 :is-lock="widget.isLock"
                 :is-move="widget.isMove"
                 :is-resize="widget.isResize"
                 :ha-members="haMembers"
                 :contents="widget.contents"
                 :layout-instance="$el"
                 :on-load-internal-component="onLoadInternalComponent"
                 @openMaximumWidget="onExpandWidget"
                 @removeTargetWidget="onRemoveWidget"
    >
    </grid-widget>
  </div>
</template>
<script>
  // Util.JS 불러오기
  import * as Utils from './utils'

  // Widget 불러오기
  import GridWidget from './GridWidget'

  export default {
    name: 'GridLayout',
    components: {
      GridWidget
    },
    directives: {},
    mixins: [],
    props: {
      uuid: {
        type: String,
        default: ''
      },
      isLock: {
        type: Boolean,
        default: false
      },
      options: {
        type: Object,
        default: () => {}
      },
      widgets: {
        type: Array,
        default: () => []
      },
      haMembers: {
        type: Array,
        default: () => []
      },
      onRemoveFunction: {
        type: Function,
        default: () => function () {}
      },
      onExpandFunction: {
        type: Function,
        default: () => function () {}
      },
      onMoveWidgetFunction: {
        type: Function,
        default: null
      },
      onResizeWidgetFunction: {
        type: Function,
        default: null
      },
      onLoadInternalComponent: {
        type: Function,
        default: () => function () {}
      }
    },
    data () {
      return {
        self: this
      }
    },
    computed: {},
    beforeCreate () {},
    created () {
      this.$nextTick(function () {
        // 원컬럼모드 제거
        this.options.disableOneColumnMode = true

        // 기본 설정 - 최소 너비, 높이 설정
        this.options.minWidth = 1
        this.options.maxWidth = 3
        this.options.cellHeight = '285px'

        // Grid layout 초기화
        Utils.createGridLayout('.grid-stack', this.options, this.onMoveWidgetFunction, this.onResizeWidgetFunction)

        // 그리드 사이즈 조절
        this.onResizeLayout()
      })

      // 리사이즈 이벤트 디바운스 연결
      this._onResizeLayout = _.throttle(this.onResizeLayout, 250)

      // 리사이즈 이벤트 연결
      window.addEventListener('resize', this._onResizeLayout)
    },
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 레이아웃 리사이즈 이벤트 제거
      window.removeEventListener('resize', this._onResizeLayout)

      // 레이아웃 인스턴스 제거
      Utils.destroyGridLayout(this.$el)

      // 속성 초기화
      this._onResizeLayout = null

      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      /*
        이름: initGridLayout
        설명: 그리드 레이아웃을 초기화한다. GridStack에서 위젯 엘리먼트를 모두 제거한다.
      */
      initGridLayout (callback) {
        // This 객체 저장
        const self = this.self

        // 모든 위젯요소 제거
        Utils.removeAllWidgets(self.$el)

        // Callback이 있으면 Callback 실행
        if (callback !== undefined && typeof callback === 'function') {
          callback()
        }
      },
      /*
        이름: initGridWidgets
        설명: 기존에 등록된 위젯을 모두 제거한 후 전달된 새로운 위젯으로 재구성한다.
      */
      initGridWidgets () {
        // This 객체 등록
        const self = this.self

        // 전달된 Widget들을 다시 GridStack 위젯으로 생성
        self.$nextTick(function () {
        // DOM 레이아웃을 초기화
        Utils.removeAllWidgets(self.$el)

          // 위젯으로 생성
          for (const widget of self.widgets) {
            Utils.makeWidget(self.$el, widget.i)
          }
        })
      },
      /*
        이름: onExpandWidget
        설명: 위젯 최대화 시 필요한 정보를 최대화 팝업에 전달한다.
      */
      onExpandWidget (widgetTitle, widgetId, widgetNum, widgetInstance) {
        this.onExpandFunction(widgetTitle, widgetId, widgetNum, widgetInstance)
      },
      onRemoveWidget (widgetId) {
        // 스토어에서 위젯 제거
        this.onRemoveFunction(widgetId)
      },
      onResizeLayout () {
        // 0. 브라우저 영역 구하기
        const layout = this.$el
        const layoutWidth = this.$el.clientWidth

        // 1. 레이아웃 변경 - 컬럼갯수 및 노드 업데이트 처리
        if (layoutWidth >= 1920) {
          if (Utils.getLayoutColumn(layout) !== 6) {
            Utils.setLayoutColumns(layout, 6)
          }
        } else if (layoutWidth >= 1600 && layoutWidth < 1920) {
          if (Utils.getLayoutColumn(layout) !== 5) {
            Utils.setLayoutColumns(layout, 5)
          }
        } else {
          if (Utils.getLayoutColumn(layout) !== 3) {
            Utils.setLayoutColumns(layout, 3)
          }
        }
      }
    },
    watch: {}
  }
</script>

<style scoped>
</style>
